module.exports = __webpack_public_path__ + "static/media/svg-cards.ee03ae14.svg";